<template>
    <div v-show="enabled" class="conceal">
        <i class="fas fa-circle-notch fa-spin fa-3x"></i>
    </div>
</template>

<script type="text/javascript">
    var _ = require('underscore');

    export default {
        data: function() {
            return {
                promises: []
            };
        },

        created: function() {
            var self = this;
            eventHub.$on('loader', function(promise) {self.loaderEvent(promise);});
        },

        computed: {
            enabled: function() {
                return this.promises.length > 0;
            }
        },

        methods: {
            loaderEvent: function(promise) {
                this.promises.push(promise);

                promise.then(_.delay(function() {
                    var index = this.promises.indexOf(promise);
                    this.promises.splice(index, 1);
                }.bind(this), 500)).catch(error => {});
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/loader.vue